var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "" } },
        [
          _vm.checkGate("users-mgmt")
            ? _c(
                "v-dialog",
                {
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      _vm.datePicker = false
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                { attrs: { color: "primary", dark: "" } },
                                on
                              ),
                              [_vm._v("New Report")]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4238949106
                  ),
                  model: {
                    value: _vm.datePicker,
                    callback: function($$v) {
                      _vm.datePicker = $$v
                    },
                    expression: "datePicker"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: {
                      range: "",
                      "first-day-of-week": 4,
                      "picker-date": ""
                    },
                    model: {
                      value: _vm.range,
                      callback: function($$v) {
                        _vm.range = $$v
                      },
                      expression: "range"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.checkGate("users-mgmt")
            ? _c(
                "v-btn",
                { attrs: { color: "gray", to: "/settings/users", link: "" } },
                [_c("v-icon", [_vm._v("mdi-cog-outline")]), _vm._v("   Users")],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "auto" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v("New Report")
                        ]),
                        _vm._v(
                          " from " +
                            _vm._s(_vm.dateRangeText) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.save($event)
                        }
                      },
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _vm.wagesbyrange.length > 0
                                    ? _c("v-data-table", {
                                        staticClass: "elevation-1 wagesForm",
                                        attrs: {
                                          headers: _vm.formHeaders,
                                          items: _vm.wagesbyrange,
                                          "items-per-page": 50,
                                          loading: _vm.loadingForm
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item.amount_paid",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "v-edit-dialog",
                                                    {
                                                      attrs: {
                                                        "return-value":
                                                          props.item.amount_paid
                                                      },
                                                      on: {
                                                        "update:returnValue": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            props.item,
                                                            "amount_paid",
                                                            $event
                                                          )
                                                        },
                                                        "update:return-value": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            props.item,
                                                            "amount_paid",
                                                            $event
                                                          )
                                                        },
                                                        save: function($event) {
                                                          return _vm.addIndex(
                                                            props.item
                                                          )
                                                        }
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "input",
                                                            fn: function() {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Edit",
                                                                      "single-line":
                                                                        "",
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        props
                                                                          .item
                                                                          .amount_paid,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          props.item,
                                                                          "amount_paid",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "props.item.amount_paid"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            props.item
                                                              .amount_paid
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "item.detail",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "v-edit-dialog",
                                                    {
                                                      attrs: {
                                                        "return-value":
                                                          props.item.detail
                                                      },
                                                      on: {
                                                        "update:returnValue": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            props.item,
                                                            "detail",
                                                            $event
                                                          )
                                                        },
                                                        "update:return-value": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            props.item,
                                                            "detail",
                                                            $event
                                                          )
                                                        },
                                                        open: _vm.edit
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "input",
                                                            fn: function() {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Reason for pay over or under"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        props
                                                                          .item
                                                                          .detail,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          props.item,
                                                                          "detail",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "props.item.detail"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            props.item.detail
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3605636254
                                        )
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.wages_reports,
          loading: _vm.loadingForm,
          "items-per-page": 10
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "", color: "red" },
                    on: {
                      click: function($event) {
                        return _vm.deleteReport(item.id)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-delete-forever")
                    ])
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "item.startDate",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "router-link",
                  {
                    attrs: {
                      tag: "a",
                      to: {
                        path:
                          "/wagesreport/" + item.startDate + "_" + item.endDate
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            new Date(item.startDate).toLocaleString("en-AU", {
                              timeZone: "UTC",
                              weekday: "short",
                              month: "short",
                              day: "numeric"
                            })
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" -\n                "),
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            new Date(item.endDate).toLocaleString("en-AU", {
                              timeZone: "UTC",
                              weekday: "short",
                              year: "numeric",
                              month: "short",
                              day: "numeric"
                            })
                          ) +
                          "\n                "
                      )
                    ])
                  ]
                )
              ]
            }
          },
          {
            key: "item.amount_paid",
            fn: function(props) {
              return [
                _c(
                  "v-edit-dialog",
                  {
                    attrs: { "return-value": props.item.amount_paid },
                    on: {
                      "update:returnValue": function($event) {
                        return _vm.$set(props.item, "amount_paid", $event)
                      },
                      "update:return-value": function($event) {
                        return _vm.$set(props.item, "amount_paid", $event)
                      },
                      save: function($event) {
                        return _vm.addIndex(props.item)
                      },
                      open: function($event) {
                        return _vm.edit(props.item)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function() {
                            return [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Edit",
                                  "single-line": "",
                                  type: "number"
                                },
                                model: {
                                  value: props.item.amount_paid,
                                  callback: function($$v) {
                                    _vm.$set(props.item, "amount_paid", $$v)
                                  },
                                  expression: "props.item.amount_paid"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.item.amount_paid) +
                        "\n                "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "item.detail",
            fn: function(props) {
              return [
                _c(
                  "v-edit-dialog",
                  {
                    attrs: { "return-value": props.item.detail },
                    on: {
                      "update:returnValue": function($event) {
                        return _vm.$set(props.item, "detail", $event)
                      },
                      "update:return-value": function($event) {
                        return _vm.$set(props.item, "detail", $event)
                      },
                      open: function($event) {
                        return _vm.edit(props.item)
                      },
                      save: _vm.save
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function() {
                            return [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Reason for pay over or under"
                                },
                                model: {
                                  value: props.item.detail,
                                  callback: function($$v) {
                                    _vm.$set(props.item, "detail", $$v)
                                  },
                                  expression: "props.item.detail"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.item.detail) +
                        "\n                "
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }